export default __webpack_public_path__ + "static/media/fw-abigail-er-Yellow Gold.b6d69cd5.mp4";